<script>
import domHelpersElementsList from '~/src/utils/domHelpers/elementsList';
import { selectorDatasetTag } from '~/src/plugins/endToEndTestsHelper/config';

export default {
    name: 'WrapperElementE2E',
    functional: true,
    props: {
        /**
         * Unique identifier needed for e2e testing
         */
        testId: {
            type: String,
            required: true,
        },
        /**
         * Html element for wrapper
         */
        htmlElement: {
            type: String,
            default: 'div',
            /**
             * Check if the value represents the html element
             * @param value
             * @returns {boolean}
             */
            validator(value) {
                return domHelpersElementsList.indexOf(value) >= 0;
            },
        },
    },
    render(h, { props, data, children }) {
        const attrs = {
            ...data.attrs,
        };

        if (process.env.handleE2E) {
            attrs[`data-${selectorDatasetTag}`] = props.testId;
        }

        return h(props.htmlElement, {
            ...data,
            attrs,
        }, children);
    },
};
</script>
